import { createMuiTheme } from '@material-ui/core';
import { GLOBAL_FONT_THEME } from 'theme/CommonTheme';

/*const theme = {
    spacing: {
        unit: 50
    },
};*/

export const CONNECTION_THEME = createMuiTheme({
    overrides: {
        // Name of the component ⚛️ / style sheet
        MuiExpansionPanelSummary: {
            root: {
                //display: "flex",
                background: '#005F9E',
                //background: "#007bff",
                //background: "#cfe1ee",
                borderTopRightRadius: '5px',
                borderTopLeftRadius: '5px',
                minHeight: 48,
                height: 48,
                '&$expanded': {
                    minHeight: 48,
                    height: 48
                }
            },
            expandIcon: {
                color: 'black'
            }
            /*spacing: {
                unit: 10
            },*/
        },
        MuiExpansionPanelActions: {
            spacing: {
                marginLeft: '70px'
            },
            root: {
                paddingTop: '20px'
            }
        },
        MuiExpansionPanelDetails: {
            root: {
                display: 'block',
                height: '270px',
                overflow: 'auto',
                overflowX: 'auto'
            }
        },
        MuiFormControl: {
            root: {
                marginNormal: {
                    marginTop: '8px !important'
                },
                //marginBottom : "20px",
                //minWidth: "300px",
                display: 'flex',
                flexWrap: 'wrap'
                //width : "100%"
            }
        },
        MuiFormLabel: {
            root: {
                color: '#005f9e'
            }
        },
        MuiSelect: {
            select: {
                fontWeight: 'bold'
            }
        },
        MuiInputBase: {
            input: {
                //padding: "8.5px 10px !important",
                paddingBottom: '10px',
                fontSize: '14px'
            }
        },
        MuiTypography: {
            root: {
                color: 'black',
                width: '100%'
                //color : "#005f9e"
            },
            header: {
                color: '#005f9e',
                fontFamily: 'Open Sans',
                fontSize: '30px !important',
                fontWeight: '600'
            },
            body1: {
                color: '#005f9e',
                backgroundColor: '#f9f9fb',
                fontFamily: 'Open Sans',
                fontSize: '15px !important',
                fontWeight: '600',
                //paddingLeft: "10px",
                width: '644px',
                height: '350px',
                border: '1px solid #bfbfc7'
            },
            body2: {
                fontSize: '12px !important',
                fontWeight: '600',
                color: '#005f9e'
            },
            colorSecondary: {
                color: 'rgba(0, 0, 0, 0.54)'
            },
            caption: {
                fontSize: '14px !important'
            }
        },
        MuiPaper: {
            root: {
                height: '50px'
            }
        },
        MuiAppBar: {
            root: {
                width: '100%',
                //marginLeft: "10px",
                //marginTop : "10px",
                height: '45px'
            },
            colorPrimary: {
                color: '#ffbe00',
                backgroundColor: '#005f9e',
                fontFamily: 'Roboto',
                fontWeight: 'bold'
            },
            colorSecondary: {
                color: '#ffffff',
                backgroundColor: '#005f9e',
                fontFamily: 'Roboto',
                fontWeight: 'bold'
            }
        },
        MuiSvgIcon: {
            root: {
                height: 20
            }
        },
        MuiCheckbox: {
            root: {
                '&$checked': {
                    color: '#002D5B !important'
                }
            },
            colorSecondary: {
                '&$checked': {
                    color: '#002D5B !important'
                }
            }
        },
        MuiDialog: {
            paperWidthSm: {
                maxWidth: '400px',
                maxHeight: 200
            }
        },
        MuiList: {
            root: {
                maxHeight: 222
                // overflowX: "auto",
                // //height: "400px", /*your fixed height*/
                // webkitColumnCount : 5,
                // mozColumnCount: 5,
                // columnCount: 2
            }
        },
        MuiListItem: {
            root: {
                // display: "inline-block",
                // fontSize: "small",
                // fontStyle: "Roboto"
            }
        },
        MuiMenu: {
            paper: {
                height: 'auto'
            }
        },
        MuiChip: {
            colorPrimary: {
                color: 'pink',
                backgroundColor: 'yellow'
            },
            clickableColorPrimary: {
                '&:hover,&:focus': {
                    color: 'red',
                    backgroundColor: 'green'
                },
                '&:click': {
                    color: 'red',
                    backgroundColor: 'green'
                },
                '&:active': {
                    color: 'red',
                    backgroundColor: 'green'
                }
            }
        },
        MuiGrid: {
            container: {
                maxHeight: '400px',
                width: '100%',
                paddingLeft: '10px',
                paddingTop: '10px'
            },
            grid: {
                //width: "200px",
                width: '100%'
            },
            item: {
                //marginLeft : "10px",
                marginRight: '10px',
                marginTop: '0px',
                marginBottom: '10px'
            },
            'grid-xs-3': {
                maxWidth: '30%'
            }
        },
        MuiTabs: {
            indicator: {
                backgroundColor: '#ffbe00'
            }
        },
        MuiTableCell: {
            head: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: '15px',
                padding: '10px 15px'
            },
            body: {
                padding: '10px 15px'
            }
        }
    },
    typography: {
        useNextVariants: true,
        root: {
            fontColor: '#005f9e'
        }
    }
});

export const MULTI_THEME = createMuiTheme({
    overrides: {
        MuiTypography: {
            root: {
                color: 'black '
            },
            body1: {
                fontSize: '13px !important',
                fontWeight: '600'
            },
            caption: {
                fontSize: '14px !important'
            }
        },
        MuiFormControl: {
            root: {
                width: '100%'
            }
        },
        MuiChip: {
            root: {
                '&:not(:first-child)': {
                    marginLeft: '5px'
                },
                backgroundColor: '#005F9E !important',
                color: 'white !important'
            }
        },
        MuiCheckbox: {
            root: {
                '&$checked': {
                    color: '#002D5B !important'
                }
            }
        },
        MuiInputBase: {
            input: {
                fontSize: '12px'
            }
        },
        MuiGrid: {
            item: {
                marginRight: 2
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const GRID_THEME = createMuiTheme({
    overrides: {
        MuiGrid: {
            container: {
                paddingBottom: 20,
                paddingRight: 10
            },
            item: {
                paddingRight: 2
            },
            'grid-xs-3': {
                marginTop: 29
            }
        },
        MuiPopover: {
            paper: {
                padding: '9px 15px',
                height: '180px',
                minWidth: '370px'
            }
        }
    }
});

export const SHIPPER_GRID_THEME = createMuiTheme({
    overrides: {
        MuiGrid: {
            container: {
                paddingBottom: 20,
                paddingRight: 10
            },
            item: {
                paddingRight: 2
            },
            'grid-xs-3': {
                marginTop: 29
            }
        },
        MuiPopover: {
            paper: {
                padding: '9px 15px',
                height: '217px',
                minWidth: '370px',
                maxWidth: '580px',
                overflow: 'hidden'
            }
        }
    }
});

export const GRID_THEME_GROUP = createMuiTheme({
    overrides: {
        MuiGrid: {
            container: {
                paddingBottom: 20,
                paddingRight: 10
            },
            item: {
                paddingRight: 2
            },
            'grid-xs-3': {
                marginTop: 29
            }
        },
        MuiPopover: {
            paper: {
                padding: '9px 15px',
                height: '250px',
                minWidth: '370px'
            }
        }
    }
});

export const AUTO_COMP_THEME = createMuiTheme({
    overrides: {
        MuiInputLabel: {
            formControl: {
                fontSize: '20px',
                width: '85%',
                marginTop: '-5px',
                color: 'black'
            }
        },
        MuiInput: {
            underline: {
                '&:hover:not($disabled):before': {
                    borderBottom: 'none !important'
                },
                '&:after': {
                    borderBottom: 'none'
                },
                '&:before': {
                    borderBottom: 'none'
                }
            }
        },
        MuiInputBase: {
            input: {
                margin: '10px 0',
                width: '100%'
            }
        },
        MuiChip: {
            root: {
                height: '28px',
                '&:not(:first-child)': {
                    marginLeft: '5px'
                },
                backgroundColor: '#cee1ee !important',
                color: 'black !important'
            }
        },
        MuiPaper: {
            root: {
                maxHeight: '90px',
                overflow: 'auto'
            }
        }
    }
});

export const SPINNER_THEME = createMuiTheme({
    overrides: {
        MuiCircularProgress: {
            root: {
                padding: 10
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const TABLEHEAD_THEME = createMuiTheme({
    overrides: {
        MuiTableCell: {
            head: {
                paddingLeft: 14,
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 0,
                fontSize: '15px !important',
                fontWeight: 'bold',
                color: 'black'
            }
        }
    }
});

export const TABLECELL_THEME = createMuiTheme({
    overrides: {
        MuiTableCell: {
            body: {
                paddingLeft: 14,
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 80
                //fontSize : "15px !important",
                //fontWeight : "bold",
                //color : "black"
            }
        }
    }
});
